import { render, staticRenderFns } from "./AeButtonGroup.vue?vue&type=template&id=b639fa42&scoped=true"
var script = {}
import style0 from "./AeButtonGroup.vue?vue&type=style&index=0&id=b639fa42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b639fa42",
  null
  
)

export default component.exports